import { createDivIn, createImgIn, createParagraphIn } from '../../ui_utils/DomUtils.ts';
export class UIProgressBadgeElement {
    update(data) {
        this.currentData = data;
        this.render();
    }
    remove() {
        this.container.remove();
        this.currentData = undefined;
    }
    render() {
        if (this.currentData == undefined) return;
        this.container.replaceChildren();
        var _this_currentData_placement;
        const placement = (_this_currentData_placement = this.currentData.placement) !== null && _this_currentData_placement !== void 0 ? _this_currentData_placement : 'topRight';
        this.container.className = placement === 'bottomRow' ? 'mm-mode-card-status-badge' : 'mm-mode-card-progress';
        if (this.currentData.backgroundColorClass != undefined) this.container.classList.add(this.currentData.backgroundColorClass);
        createImgIn(this.container, this.currentData.icon);
        createParagraphIn(this.container, this.currentData.text, '');
    }
    constructor(parent, initialData){
        var _initialData_placement;
        const placement = (_initialData_placement = initialData === null || initialData === void 0 ? void 0 : initialData.placement) !== null && _initialData_placement !== void 0 ? _initialData_placement : 'topRight';
        const className = placement === 'bottomRow' ? 'mm-mode-card-status-badge' : 'mm-mode-card-progress';
        this.container = createDivIn(parent, className);
        if (initialData != undefined) this.update(initialData);
    }
}
